module.exports = ".mat-drawer:not(.mat-drawer-side){box-shadow:none}\n"